<section>
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small">Send Response.</div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="user-profile__form">
                <section>
                    <div class="card-body p-4">
                        <form>
                            <div class="table-responsive">
                                <table class="table table-striped mb-0 table-hover table-bordered" [formGroup]="feedbackForm">
                                    <thead>
                                      <tr>
                                        <!-- <th scope="col">PR#</th>
                                        <th scope="col">Total #POs</th>
                                        <th scope="col">PO#</th>
                                        <th scope="col">Line Item#</th>
    
                                        <th scope="col">Acknowledgment status ( Can PO be delivered )</th>
                                        <th scope="col">Remarks</th>
                                        <th scope="col">Delivery Date</th> -->


                                        <th scope="col">PO Number</th>
                                        <th scope="col">Line Item Id</th>
                                        <th scope="col">Confirmation Id</th>
                                        <th scope="col">Indicator</th>
                                        <th scope="col">Material Code</th>
                                        <th scope="col">HSN/SAC Code</th>
                                        <th scope="col">Confirmed Delivery Date</th>
                                        
                                        <th scope="col">Confirmed Quantity</th>
                                        <th scope="col">Price</th>
                                        <th scope="col">UOM</th>
                                        <th scope="col">Currency</th>

                                      </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngIf="deliveryAck.length;else noData">
                                            <tr *ngFor="let po of deliveryAck; let i = index">
                                                <td scope="col">{{po.po_number}}</td>
                                                <td scope="col">{{po.line_item_id}}</td>
                                                <td scope="col">{{po.confirmation_id}}</td>
                                                <td scope="col">
                                                    {{po.indicator}}
                                                </td>
                                                <td scope="col">{{po.material_code}}</td>
                                                <td scope="col">{{po.hsn_sac_code}}</td>
                                                <td scope="col">{{po.confirmed_deli_date}}</td>
                                                <td scope="col">{{po.confirmed_quantity}}</td>
                                                <td scope="col">{{po.price}}</td>
                                                <td scope="col">{{po.uom}}</td>
                                                <td scope="col">{{po.hsn_sac_code}}</td>
                                                <td scope="col">{{po.currency}}</td>

                                            </tr>
                                            <!-- <ng-container [formArrayName]="po.pr_number">
                                                <ng-container *ngFor="let b of getFormArrayName(po.pr_number); let j = index">
                                                    <ng-container [formGroupName]="j">
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                
                                                            <td>
                                                                #{{getFormArrayName(po.pr_number).at(j).get('po_number').value}}
                                                            </td>
                                                            <td></td>
                                                            <td>
                                                                <div class="my-1">
                                                                   
                                                                    <select class="form-select" aria-label=".form-select-sm example"
                                                                    formControlName="supplier_acknowledgment_status"
                                                                    [error]="getFormArrayName(po.pr_number).at(j).get('supplier_acknowledgment_status')">
                                                                        <option selected disabled value="">Select</option>
                                                                        <option value="Yes">Yes</option>
                                                                        <option value="No">No</option>
                                                                    </select>
                                                                    <form-feedback [formGroup]="getFormArrayName(po.pr_number).at(j)" field="supplier_acknowledgment_status"></form-feedback>
                                                                </div> 
                                                            </td>
                                                            <td>
                                                                <div class="my-1">
                                                                    <input type="text" id="vendor_remarks" class="form-control"
                                                                    formControlName="vendor_remarks"
                                                                    [error]="getFormArrayName(po.pr_number).at(j).get('vendor_remarks')">
                                                                    <form-feedback [formGroup]="getFormArrayName(po.pr_number).at(j)" field="vendor_remarks"></form-feedback>
                                                                </div> 
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                
                                                        <ng-container [formArrayName]="'line_item_data'">
                                                            <tr *ngFor="let line_item of getFormArrayName(po.pr_number).at(j).get('line_item_data').controls; let k = index">
                                                                <ng-container [formGroupName]="k">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td>
                                                                        {{getFormArrayName(po.pr_number).at(j).get('line_item_data').at(k).get('line_item_number').value}}
                                                                    </td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td>
                                                                        <div class="my-1">
                                                                            <input type="date" id="estimated_delivery_date" class="form-control"
                                                                            formControlName="estimated_delivery_date"
                                                                            [error]="getFormArrayName(po.pr_number).at(j).get('line_item_data').at(k).get('estimated_delivery_date')">
                                                                            <form-feedback [formGroup]="getFormArrayName(po.pr_number).at(j).get('line_item_data').at(k)" field="estimated_delivery_date"></form-feedback>
                                                                        </div>
                                                                    </td>
                                                                </ng-container>
                                                            </tr> 
                                                        </ng-container>
                                                        
                                                    </ng-container>                   
                                                </ng-container>
                                            </ng-container> -->
                                        </ng-container>
                                        <ng-template #noData>
                                            <div class="pt-5">No data found</div>
                                        </ng-template>
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div>
            <!-- <button type="button" class="btn btn-lg btn-primary text-white" (click)="updateInfo()" [disabled]="!feedbackForm.valid">Send Details</button> -->
        </div>
    </div>
</section>